import { gql } from "@apollo/client";

export const SEND_LG = gql`
  mutation sendLg($input: SendLgInput!) {
    invoice {
      sendLg(input: $input) {
        success
      }
    }
  }
`;
